module.exports = __webpack_public_path__ + "img/reference09.19207cf1.jpg";